import React, { useState, useContext, useEffect } from "react";
import ListVariantStyle from "../../../../../assets/css/components/admin/products/ListVariants.css";
import { Container, Row, Col, Image, Form, InputGroup } from "react-bootstrap";
import ImgTest from "../../../../../assets/img/jpeg/img_test.jpg";
import axios from "axios";
import { getVariantDescription } from "../../../../../assets/js/productHelper";
import {
    keyUserId,
    keyAccessToken,
} from "../../../../../assets/js/SessionStorageNames";
import { GlobalContext } from "../../../../../contexts/GlobalContext";
import ListFiltersStyles from "../../../../../assets/css/components/admin/filters/ListFiltersCss";
import { Spinner } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../../../assets/css/components/admin/marketplace-to-marketplace/filters/FiltersStyles";
import { accVtex } from "../../../../../hooks/api/vtex";

export default function ListVariants(props) {
    const globalContext = useContext(GlobalContext);
    const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedVariant, setSelectedVariant] = useState(null);

    const loader = () => {
        switch (props.variants.length > 0) {
            case true:
                setLoading(false)
                break;
            case false:
                setLoading(true)
                break;
            default:
                break;
        }
    }    

    // Filtrar variantes basado en el término de búsqueda
    const filteredVariants = props.variants.filter((variant) => {
        if (!searchTerm) return true;
        
        const searchLower = searchTerm.toLowerCase();
        const sku = variant.attrib?.sellerSku || variant.attrib?.barCode || "";
        const title = variant.title || "";
        const variantDesc = variant.variantDesc || "";
        
        return (
            sku.toLowerCase().includes(searchLower) ||
            title.toLowerCase().includes(searchLower) ||
            variantDesc.toLowerCase().includes(searchLower)
        );
    });

    // Función para seleccionar una variante
    const handleVariantSelect = (variantId) => {
        setSelectedVariant(variantId);
        updateProductToLink(variantId);
    };

    useEffect(() => {
        loader();
    },[props])
    
    /**
     * Update the product data
     */
    const updateProductToLink = (id) => {
        const headerParams = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
        };

        switch (props.plugin) {
            case "odoo":
                axios
                    .get(
                        `${process.env.REACT_APP_BACKEND_URL}/v1/odoo/${props.entId}/${id}`,
                        {
                            cancelToken: axiosCancelTokenSource.token,
                            headers: headerParams,
                            params: {
                                linked: true,
                            },
                        }
                    )
                    .then((resp) => {
                        const data = resp.data.data;

                        const linked = data.linked;
                        //Set the linked variants description
                        if (linked.length > 0) {
                            for (const l of linked) {
                                l.saved = true;
                                if (l.product.isVariant) {
                                    l.product.variantDesc =
                                        getVariantDescription(
                                            l.product,
                                            l.product.plugin
                                        );
                                }
                            }
                        }

                        props.setProductData({
                            productToLinkId: data._id,
                            title: data.title,
                            price: data.price,
                            stock: data.stock,
                            thumbnail:
                                data.thumbnail &&
                                typeof data.thumbnail == "object" &&
                                data.thumbnail.url
                                    ? data.thumbnail.url
                                    : data.thumbnail &&
                                      typeof data.thumbnail == "string"
                                    ? `data:image/png;base64,${data.thumbnail}`
                                    : false,
                            isVariant: data.isVariant,
                            hasVariants: data.hasVariants,
                            linked,
                            barCode: data.attrib.barCode,
                        });

                        //Set the variation data
                        if (data.isVariant) {
                            props.setVariantDesc(
                                getVariantDescription(data, "odoo")
                            );
                        }
                    })
                    .catch((err) => {
                        if (axios.isCancel(err)) return; //Don't show axios cancel error

                        globalContext.showModalWithMsg(
                            "Disculpe, hubo un error al intentar cargar los datos del producto."
                        );
                        console.error(err, err.response);
                    });
                break; //End odoo

            case "ml":
                axios
                    .get(
                        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-product/${props.entId}/${id}`,
                        {
                            cancelToken: axiosCancelTokenSource.token,
                            headers: headerParams,
                            params: {
                                linked: true,
                            },
                        }
                    )
                    .then((resp) => {
                        const data = resp.data.data;

                        const linked = data.linked;
                        //Set the linked variants description
                        if (linked.length > 0) {
                            for (const l of linked) {
                                l.saved = true;
                                if (l.product.isVariant) {
                                    l.product.variantDesc =
                                        getVariantDescription(
                                            l.product,
                                            l.product.plugin
                                        );
                                }
                            }
                        }

                        props.setProductData({
                            productToLinkId: data._id,
                            title: data.title,
                            price: data.price,
                            stock: data.stock,
                            thumbnail: data.thumbnail,
                            isVariant: data.isVariant,
                            hasVariants: data.hasVariants,
                            linked,
                            barCode: data.attrib.barCode,
                            officialStoreId: data.attrib.official_store_id,
                        });

                        //Set the variant data (if the product is a variant)
                        if (data.isVariant) {
                            const desc = getVariantDescription(data, "ml");
                            props.setVariantDesc(desc);
                        }
                    })
                    .catch((err) => {
                        if (axios.isCancel(err)) return; //Don't show axios cancel error

                        globalContext.showModalWithMsg(
                            "Disculpe, hubo un error al intentar cargar los datos del producto."
                        );
                        console.error(err, err.response);
                    });
                break; //End ml

            case "fl":
                axios
                    .get(
                        `${process.env.REACT_APP_BACKEND_URL}/v1/fala-product/${props.entId}/${id}`,
                        {
                            cancelToken: axiosCancelTokenSource.token,
                            headers: headerParams,
                            params: {
                                linked: true,
                            },
                        }
                    )
                    .then((resp) => {
                        const data = resp.data.data;
                        console.log("data: ", data)

                        const linked = data.linked;
                        //Set the linked variants description
                        if (linked.length > 0) {
                            for (const l of linked) {
                                l.saved = true;
                                if (l.product.isVariant) {
                                    l.product.variantDesc =
                                        getVariantDescription(
                                            l.product,
                                            l.product.plugin
                                        );
                                }
                            }
                        }

                        props.setProductData({
                            productToLinkId: data._id,
                            title: data.title,
                            price: data.price,
                            stock: data.stock,
                            thumbnail: data.thumbnail,
                            isVariant: data.isVariant,
                            hasVariants: data.hasVariants,
                            linked,
                            barCode: data.attrib.sellerSku,
                            //officialStoreId: data.attrib.official_store_id,
                        });

                        //Set the variant data (if the product is a variant)
                        if (data.isVariant) {
                            const desc = getVariantDescription(data, "fl");
                            props.setVariantDesc(desc);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        if (axios.isCancel(err)) return; //Don't show axios cancel error

                        globalContext.showModalWithMsg(
                            "Disculpe, hubo un error al intentar cargar los datos del producto."
                        );
                        console.error(err, err.response);
                    });
                break; //End falabella

            case "homeCenter":
                axios
                .get(
                    `${process.env.REACT_APP_BACKEND_URL}/v1/home-center-products/get-product/${props.entId}/${id}`,
                    {
                        cancelToken: axiosCancelTokenSource.token,
                        headers: headerParams,
                        // params: { linked: true }, 
                    }
                )
                .then((resp) => {
                    const data = resp.data.data;
                    
                    // Convertir odooProduct a la estructura esperada por ProductsAssoc
                    const linked = data.odooProduct ? [{
                        product: {
                            _id: data.odooProduct._id,
                            title: data.odooProduct.title,
                            sku: data.odooProduct.sku,
                            stock: data.odooProduct.stock,
                            price: data.odooProduct.price,
                            plugin: data.odooProduct.plugin,
                            barCode: data.odooProduct.barCode,
                            thumbnail: null, // odooProduct no tiene thumbnail en los datos mostrados
                            isVariant: false, // asumimos que no es variante por ahora
                            variantDesc: null,
                            odooProductId: data.odooProduct._id // ID del producto de Odoo
                        },
                        saved: true
                    }] : [];
                    
                    // Usamos props.setProductData para establecer el producto seleccionado
                    props.setProductData({
                        productToLinkId: data._id,
                        title: data.title,
                        price: data.odooProduct?.price || 0,
                        stock: data.stock,
                        thumbnail: null, // HomeCenter no tiene thumbnail en los datos mostrados
                        isVariant: false, // asumimos que no es variante por ahora
                        hasVariants: false,
                        linked,
                        barCode: data.barCode,
                        categories: [],
                        images: []
                    });
                })
                .catch((err) => {
                    if (axios.isCancel(err)) return; //Don't show axios cancel error
                    globalContext.showModalWithMsg(
                        "Disculpe, hubo un error al intentar cargar los datos del producto."
                    );
                    console.error(err, err.response);
                });
                break; //End homeCenter

            case "vtex":
                accVtex('GET', props.entId, 'idmc').then((res)=> {
                    const accId = Object.values(res.data).map(item => item._id).toString()
                    axios
                        .get(
                            `${process.env.REACT_APP_BACKEND_URL}/v1/vtex-prod/${props.entId}/acc/${accId}/product/${id}`,
                            {
                                cancelToken: axiosCancelTokenSource.token,
                                headers: headerParams,
                                params: {
                                    linked: true,
                                },
                            }
                        )
                        .then((resp) => {
                            const data = resp.data.data;

                            const linked = data.linked;
                            //Set the linked variants description
                            if (linked.length > 0) {
                                for (const l of linked) {
                                    l.saved = true;
                                    if (l.product.isVariant) {
                                        l.product.variantDesc =
                                            getVariantDescription(
                                                l.product,
                                                l.product.plugin
                                            );
                                    }
                                }
                            }

                            props.setProductData({
                                productToLinkId: data._id,
                                title: data.title,
                                price: data.price,
                                stock: data.stock,
                                thumbnail: data.thumbnail && data.thumbnail.length > 0 ? data.thumbnail[0] : null,
                                isVariant: data.isVariant,
                                hasVariants: data.hasVariants,
                                linked,
                                barCode: data.barCode,
                                vtexId: data.vtexId,
                                categoryId: data.categoryId,
                                brandId: data.brandId,
                                warehouseId: data.warehouseId,
                            });

                            //Set the variant data (if the product is a variant)
                            if (data.isVariant) {
                                const desc = getVariantDescription(data, "vtex");
                                props.setVariantDesc(desc);
                            }
                        })
                        .catch((err) => {
                            if (axios.isCancel(err)) return; //Don't show axios cancel error

                            globalContext.showModalWithMsg(
                                "Disculpe, hubo un error al intentar cargar los datos del producto VTEX."
                            );
                            console.error(err, err.response);
                        });
                })
                .catch((err) => {
                    if (axios.isCancel(err)) return; //Don't show axios cancel error

                    globalContext.showModalWithMsg(
                        "Disculpe, hubo un error al obtener la cuenta de VTEX."
                    );
                    console.error(err, err.response);
                });
              break;
            
            default:
                break;
        }
    };
    return (
        <ListVariantStyle height={props.height || "300px"}>
            <div className={`list-variant ${loading || props.isVariant ? 'd-flex align-items-start justify-content-center' : ''}`}>
            {loading || props.baseProduct ? 
                <Col className="">
                    {props.baseProduct ? 
                        <div className="text-center">
                            <p className="text-sp">
                                El producto es una variante
                            </p>
                            <a href={`/admin/productos/detail-products/${props.pluginName === "vtex" && props.odooProductParentId ? "odoo" : props.pluginName}/${props.pluginName === "vtex" && props.odooProductParentId ? props.odooProductParentId : props.baseProduct}`} style={{margin: '0px auto'}} className="btn btn-primary">
                                {props.pluginName === "vtex" && props.odooProductParentId ? "Ir a la variante" : "Ir al producto padre"}
                                {/* <FontAwesomeIcon icon={Arrow} /> */}
                            </a>
                        </div>
                    : props.pluginName === "vtex" && !props.isSynchronized ?
                        <div className="text-center">
                            <p className="text-sp">
                                El producto no está sincronizado
                            </p>
                        </div>
                    :
                        <ListFiltersStyles.contLoader>
                            <Spinner animation="border" role="status">
                                <span className="sr-only">Cargando...</span>
                            </Spinner>
                        </ListFiltersStyles.contLoader>
                    }
                </Col>
            :
                <Container>
                    <Row className="mb-3 mt-4">
                        <Col xs={12}>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Buscar por SKU, título o variante..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="form-control-sm search-input"
                                />
                                {searchTerm && (
                                    <InputGroup.Text 
                                        style={{cursor: 'pointer'}}
                                        onClick={() => setSearchTerm("")}
                                    >
                                        <FontAwesomeIcon icon="times" />
                                    </InputGroup.Text>
                                )}
                            </InputGroup>
                        </Col>
                    </Row>
                    
                    {/* Información de resultados */}
                    {searchTerm && (
                        <Row className="mb-2">
                            <Col xs={12}>
                                <small className="text-muted">
                                    Mostrando {filteredVariants.length} de {props.variants.length} variantes
                                </small>
                            </Col>
                        </Row>
                    )}
                    
                    <Row>
                        {filteredVariants.length > 0 ? (
                            filteredVariants.map((p) => {
                                const thumbnail =
                                    p.thumbnail &&
                                    typeof p.thumbnail == "object" &&
                                    p.thumbnail.url
                                        ? p.thumbnail.url
                                        : p.thumbnail &&
                                          typeof p.thumbnail == "string" &&
                                          p.plugin === "odoo"
                                        ? `data:image/png;base64,${p.thumbnail}`
                                        : p.plugin === "ln" || p.plugin === "df"
                                        ? p.thumbnail
                                        : false;

                                return (
                                    <Col
                                        key={p._id}
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                        className='d-flex justify-content-center align-items-center pt-2 pb-2'
                                    >
                                        <Image
                                            title={p.variantDesc}
                                            className={`imgVariant ${selectedVariant === p._id ? 'selected' : ''}`}
                                            src={thumbnail || ImgTest}
                                            alt={p.variantDesc}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                handleVariantSelect(p._id);
                                            }}
                                        />
                                    </Col>
                                );
                            })
                        ) : (
                            <Col xs={12} className="text-center py-4">
                                <p className="text-muted">
                                    {searchTerm ? "No se encontraron variantes que coincidan con la búsqueda." : "No hay variantes disponibles."}
                                </p>
                            </Col>
                        )}
                    </Row>
                </Container>
            }
            </div>
        </ListVariantStyle>
    );
}
